import React, {useState, useEffect} from "react";
import {Box, FormControl, InputLabel, ListItemText, MenuItem, Select, Switch, Typography, Tooltip, Button} from "@mui/material";
import Grid from '@mui/material/Grid';
import RefreshIcon from "@mui/icons-material/Refresh";

const styles = {
    gridContainer: {
        padding: '0.25rem 0 0.25rem 1rem',
        gap: '0.5rem'
    },
    formControl: {
        minWidth: '7.5rem',
        margin: '0 0.5rem 0 1rem',
        '& .MuiInputBase-root': {
            height: '2rem',
        },
    },
    refreshButton: {
        minWidth: 'auto',
        width: '2.3rem'
    },
    switchBox: {
        display: "flex",
        alignItems: "center",
    },
    serviceMenuItem: {
        minHeight: "2rem",
        paddingX: "0.8rem",
        backgroundColor: "#ffffff",
        '&:hover': {
            backgroundColor: "#ffffff",
        },
        '&.Mui-selected': {
            backgroundColor: "#ffffff",
        },
        '&.Mui-selected:hover': {
            backgroundColor: "#ffffff",
        },
    }
};

export default function SchedulePageHeader({
                                               sortOption,
                                               setAreShiftsFiltered,
                                               areShiftsFiltered,
                                               loading,
                                               handleSortOptionUpdate,
                                               sortingDefinitions,
                                               handleManualRefresh,
                                               availableServiceTypes = [],
                                               selectedServiceTypeKeycodes = [],
                                               setSelectedServiceTypeKeycodes
                                           }) {

    const [isFilterShiftToggleStateUpdated, setIsFilterShiftToggleStateUpdated] = useState(!loading);

    useEffect(() => {
        if (!loading) {
            setIsFilterShiftToggleStateUpdated(true);
        }
    }, [loading]);

    const handleSwitchChange = (event) => {
        if (isFilterShiftToggleStateUpdated) {
            setAreShiftsFiltered(event.target.checked);
            setIsFilterShiftToggleStateUpdated(false);
        }
    };

    const handleServiceTypeChange = (event) => {
        const updatedServiceTypeKeycodes = event.target.value;

        if (updatedServiceTypeKeycodes.length === 0) {
            return;
        }

        setSelectedServiceTypeKeycodes(updatedServiceTypeKeycodes);
    };

    return (
        <Grid container alignItems="center" sx={styles.gridContainer}>
            <Grid>
                <Button variant="contained" size="small" sx={styles.refreshButton} onClick={handleManualRefresh} disabled={loading} aria-label="Refresh schedule">
                    <RefreshIcon/>
                </Button>
            </Grid>
            <Grid>
                <FormControl sx={styles.formControl} size="small">
                    <InputLabel>Sort By</InputLabel>
                    <Select
                        label="Sort By"
                        value={sortOption}
                        onChange={(event) => handleSortOptionUpdate(event.target.value)}
                        MenuProps={{MenuListProps: {sx: {paddingBottom: 0}}}}
                    >
                        {Object.keys(sortingDefinitions).map((option) => (
                            <MenuItem key={option} value={option}>
                                {sortingDefinitions[option].name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid>
                <FormControl sx={{...styles.formControl, width: '8rem'}} size="small">
                    <InputLabel shrink>Services</InputLabel>
                    <Select
                        multiple
                        displayEmpty
                        label="Services"
                        value={selectedServiceTypeKeycodes}
                        onChange={handleServiceTypeChange}
                        renderValue={(selectedServiceTypes) => (`${selectedServiceTypes.length} Selected`)}
                        MenuProps={{MenuListProps: {sx: {paddingBottom: 0}}}}>
                        {availableServiceTypes.map((serviceType) => (
                            <MenuItem key={serviceType.keycode} value={serviceType.keycode} sx={styles.serviceMenuItem}>
                                <ListItemText primary={serviceType.keycode}/>
                                <Switch size="small" checked={selectedServiceTypeKeycodes.includes(serviceType.keycode)}/>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid>
                <Box sx={styles.switchBox}>
                    <Switch checked={areShiftsFiltered} onChange={handleSwitchChange} disabled={!isFilterShiftToggleStateUpdated || loading} />
                    <Tooltip title={'Hide any services where the performer is unaccredited'}><Typography>Hide Unaccredited</Typography></Tooltip>
                </Box>
            </Grid>
        </Grid>
    );
}